<template>
   <div class="main-content group-data-[sidebar-size=lg]:xl:ml-[calc(theme('spacing.app-menu')_+_16px)] group-data-[sidebar-size=sm]:xl:ml-[calc(theme('spacing.app-menu-sm')_+_16px)] px-4 group-data-[theme-width=box]:xl:px-0 ac-transition">
        <div class="grid grid-cols-12 gap-x-4">

             <!-- Start User By Device Section -->
             <div class="col-span-full lg:col-span-12 card">
                <div class="flex-center-between">
                    <h6 class="card-title text-lg leading-none">Dashboard</h6>
                    <div class="leading-none shrink-0 text-xs text-gray-500 dark:text-dark-text dk-border-one rounded-full px-2 py-1 dk-theme-card-square">All Time</div>
                </div>
                <div class="flex flex-col h-full">
                    <div id="analytic-device-session-chart" class="flex-center grow"></div>
                    <div class="flex-center-between py-5">
                        <div >
                             <router-link :to="`/ordertakenlist?q=1`" >
                            <div class="card-title text-danger">Processing</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(processing)?processing:0}}</div>
                            </router-link>
                        </div>
                        <div>
                             <router-link :to="`/ordertakenlist?q=2`">
                            <div class="card-title text-success">Complete</div>
                            <div class="text-gray-500 dark:text-dark-text-two font-semibold ">{{(complete)?complete:0}}</div>
                              </router-link>
                        </div>
                        </div>


                </div>
            </div>
            <!-- End User By Device Section -->

           
  
            <!-- End Chat Inbox -->
        </div>
    </div>
</template>

<script>
// @ is an alias to /src 
import axios from 'axios';

export default {
  name: 'HomeView', 
mounted(){
 this.getBasics();
}, 
data() {
 return {
        processing:0,
        complete:0,
 }
 }, 
  methods:{

 async getBasics() {
       var self=this;
         axios.post('getTailorDashboard').then(function (response) {
                 self.processing=response.data.processing;
                 self.complete=response.data.complete;
       
                }).then(()=>{ 
                    self.datatable= $(".datatable").DataTable({
                            "paging": true,
                            "ordering": true,  
                            "autoWidth": false });
              
                    });;;
  }, 
  }
}
</script>
